module.exports = {
  'Details': 'Mehr',
  'reset_all': 'Alle zurücksetzen',
  'linktext': 'heidICON',
  'mehr': 'mehr',
  'Jahrzehnt': 'er',
  'Jahrhundert': 'Jahrhundert',
  'Jahrtausend': 'Jahrtausend',
}



//////////////////
// WEBPACK FOOTER
// ./js/data/l10n/de-DE.js
// module id = 12
// module chunks = 0